import React from "react";
import ReactDOM from "react-dom";

// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// @ts-ignore
// import * as serviceWorker from './serviceWorkerRegistration';
//
// serviceWorker.register();

// Sentry.init({
//     dsn: "https://4e187f99a83043ecb775594cf8965d45@o1232618.ingest.sentry.io/6380682",
//     integrations: [new BrowserTracing()],
//     tracesSampleRate: 1.0,
// });

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
